<span [class]="dotClass"></span>
{{ etapa | uppercase}}
